import { VueTagsInput } from '@vojtechlanka/vue-tags-input'
import '@vojtechlanka/vue-tags-input/style.css'

// @vojtechlanka/vue-tags-input 3 (@johmun/vue-tags-input'un Vue 3 çatalı, clientapp ile aynı; Aşama 4.8). Vue 2
// paketinin `this._events` köprüsü kalktı. Çatal etiket eklerken v-model'i (tag metni) boşaltmaz;
// JobTagsInput/CustomerTagsInput bu yüzden `@tags-changed`'de yazılan metni kendisi temizler (`isDuplicate`
// o metne bakar).
export default {
  install(app) {
    app.component('VueTagsInput', VueTagsInput)
  }
}
